import * as ng from 'angular';
import * as _ from 'underscore';

import {EditorPageController} from '../../editor';
import {ExperienceField} from '../..';

const addStandardViewUrl = require('./form-add-standard.html');
const addSurveyViewUrl = require('./add-survey-view.html');
const fieldSettingsViewUrl = require('./form-field-settings.html');

const tinymceDefaults = {
   theme: 'modern',
   plugins: 'lists link paste',
   menubar: false,
   toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link',
   link_assume_external_targets: true,
   paste_as_text: true
};

const gridsterDefaults = {
   pushing: false,
   floating: false,
   swapping: true,
   maxRows: 100000,
   columns: 2,
   minSizeX: 1,
   rowHeight: 22,
   mobileModeEnabled: false,
   margins: [5, 5],
   resizable: {
      enabled: true,
      handles: ['se']
   },
   draggable: {
      handle: '.drag'
   }
};

export const defaults = {
   strings: {
      labels: {},
      descriptions: {},
      placeholders: {},
      titles: {}
   },
   survey: [
      {
         "survey": {},
         "deletable": true,
         "editable": true,
         "type": "surveyBoolean",
         "sizeX": 2,
         "sizeY": 2,
         "minSizeY": 2
      },
      {
         "survey": {},
         "deletable": true,
         "editable": true,
         "type": "surveyText",
         "sizeX": 2,
         "sizeY": 2,
         "minSizeY": 2
      },
      {
         "survey": {},
         "deletable": true,
         "editable": true,
         "type": "surveyOption",
         "sizeX": 2,
         "sizeY": 2,
         "minSizeY": 2
      },
      {
         "key": null,
         "survey": {},
         "deletable": true,
         "editable": true,
         "type": "surveyMultioption",
         "sizeX": 2,
         "sizeY": 2,
         "minSizeY": 2
      }
   ],
   divider: {
      "key": null,
      "deletable": true,
      "editable": false,
      "type": "divider",
      "sizeX": 2,
      "sizeY": 2,
      "minSizeY": 2
   },
   textLabel: {
      "key": null,
      "deletable": true,
      "editable": true,
      "type": "textLabel",
      "sizeX": 2,
      "sizeY": 3,
      "minSizeY": 2,
      "description": {
         "en": ""
      }
   },
   eventDetails: {
      "key": null,
      "deletable": true,
      "editable": false,
      "type": "eventDetails",
      "sizeX": 2,
      "sizeY": 6,
      "minSizeY": 6
   },
   standard: [
      {
         "label": {},
         "key": "firstName",
         "row": 0,
         "col": 0,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "lastName",
         "row": 0,
         "col": 1,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "email",
         "row": 3,
         "col": 0,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "confirmEmail",
         "required": true,
         "row": 3,
         "col": 1,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "gender",
         "required": false,
         "row": 2,
         "col": 0,
         "placeholder": {},
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "dateOfBirth",
         "required": false,
         "row": 2,
         "col": 1,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "ageCategory",
         "required": false,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "addressSearch",
         "required": false,
         "row": 3,
         "col": 0,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "address",
         "required": false,
         "row": 3,
         "col": 0,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "address2",
         "required": false,
         "row": 3,
         "col": 1,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "city",
         "required": false,
         "row": 4,
         "col": 0,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "state",
         "required": false,
         "row": 4,
         "col": 1,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "zip",
         "required": false,
         "row": 3,
         "col": 1,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "phoneNumber",
         "required": false,
         "row": 5,
         "col": 1,
         "placeholder": {},
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "country",
         "required": false,
         "row": 6,
         "col": 0,
         "sizeX": 1,
         "sizeY": 3
      },
      {
         "label": {},
         "key": "contactOptin",
         "sizeX": 2,
         "sizeY": 2,
         "value": '0',
         "description": {}
      },
      {
         "label": {},
         "key": "promoOptin",
         "sizeX": 2,
         "sizeY": 2,
         "value": '0',
         "description": {}
      },
      {
         "label": {},
         "key": "contestOptin",
         "sizeX": 2,
         "sizeY": 2,
         "value": '0',
         "description": {}
      },
      {
         "label": {},
         "key": "salesOptin",
         "sizeX": 2,
         "sizeY": 2,
         "value": '0',
         "description": {}
      },
      {
         "label": {},
         "key": "termsAgree",
         "sizeX": 2,
         "sizeY": 2,
         "value": '0',
         "description": {}
      }
   ]
};

export const overrides = {
   standard: {
      "firstName": {
         "editable": true,
         "deletable": false,
         "type": "text",
         "required": true,
         "minSizeY": 3,
         "surveyId": null
      },
      "lastName": {
         "editable": true,
         "deletable": false,
         "type": "text",
         "required": true,
         "minSizeY": 3,
         "surveyId": null
      },
      "email": {
         "editable": true,
         "deletable": false,
         "type": "text",
         "required": true,
         "minSizeY": 3,
         "surveyId": null
      },
      "confirmEmail": {
         "editable": true,
         "deletable": true,
         "type": "text",
         "required": true,
         "minSizeY": 3,
         "surveyId": null
      },
      "gender": {
         "editable": true,
         "deletable": true,
         "type": "select",
         "minSizeY": 3,
         "surveyId": null
      },
      "dateOfBirth": {
         "editable": true,
         "deletable": true,
         "type": "dob",
         "minSizeY": 3,
         "surveyId": null
      },
      "ageCategory": {
         "editable": true,
         "deletable": true,
         "type": "select",
         "minSizeY": 3
      },
      "address": {
         "editable": true,
         "deletable": true,
         "type": "text",
         "minSizeY": 3,
         "surveyId": null
      },
      "addressSearch": {
         "editable": true,
         "deletable": true,
         "type": "text",
         "minSizeY": 3,
      },
      "address2": {
         "editable": true,
         "deletable": true,
         "type": "text",
         "minSizeY": 3,
         "surveyId": null
      },
      "city": {
         "editable": true,
         "deletable": true,
         "type": "text",
         "minSizeY": 3,
         "surveyId": null
      },
      "state": {
         "editable": true,
         "deletable": true,
         "type": "select",
         "minSizeY": 3,
         "surveyId": null
      },
      "zip": {
         "editable": true,
         "deletable": true,
         "type": "text",
         "minSizeY": 3,
         "surveyId": null
      },
      "phoneNumber": {
         "editable": true,
         "deletable": true,
         "type": "text",
         "minSizeY": 3,
         "surveyId": null
      },
      "country": {
         "editable": true,
         "deletable": true,
         "type": "select",
         "minSizeY": 3,
         "surveyId": null
      },
      "contactOptin": {
         "required": false,
         "editable": true,
         "deletable": true,
         "type": "optin",
         "minSizeY": 2,
         "surveyId": null
      },
      "promoOptin": {
         "required": false,
         "editable": true,
         "deletable": true,
         "type": "optin",
         "minSizeY": 2,
         "surveyId": null
      },
      "contestOptin": {
         "required": false,
         "editable": true,
         "deletable": true,
         "type": "optin",
         "minSizeY": 2,
         "surveyId": null
      },
      "salesOptin": {
         "required": false,
         "editable": true,
         "deletable": true,
         "type": "optin",
         "minSizeY": 2,
         "surveyId": null
      },
      "termsAgree": {
         "required": true,
         "editable": true,
         "deletable": true,
         "type": "optin",
         "minSizeY": 2,
         "surveyId": null
      }
   }
};

ng.module('e360').run(initLocalizedStrings);
initLocalizedStrings.$inject = ['gettextCatalog'];
function initLocalizedStrings(gettextCatalog) {
   defaults.strings.labels['firstName'] = gettextCatalog.getString('First Name');
   defaults.strings.labels['lastName'] = gettextCatalog.getString('Last Name');
   defaults.strings.labels['email'] = gettextCatalog.getString('Email Address');
   defaults.strings.labels['confirmEmail'] = gettextCatalog.getString('Confirm Email Address');
   defaults.strings.labels['gender'] = gettextCatalog.getString('Gender');
   defaults.strings.labels['dateOfBirth'] = gettextCatalog.getString('Date of Birth');
   defaults.strings.labels['ageCategory'] = gettextCatalog.getString('Age Category');
   defaults.strings.labels['address'] = gettextCatalog.getString('Address');
   defaults.strings.labels['addressSearch'] = gettextCatalog.getString('Address');
   defaults.strings.labels['address2'] = gettextCatalog.getString('Address 2');
   defaults.strings.labels['city'] = gettextCatalog.getString('City');
   defaults.strings.labels['state'] = gettextCatalog.getString('State');
   defaults.strings.labels['zip'] = gettextCatalog.getString('Zip/Postal Code');
   defaults.strings.labels['phoneNumber'] = gettextCatalog.getString('Phone Number');
   defaults.strings.labels['country'] = gettextCatalog.getString('Country');
   defaults.strings.labels['location'] = gettextCatalog.getString('Location');
   defaults.strings.labels['contactOptin'] = gettextCatalog.getString('Opt-in (Contact)');
   defaults.strings.labels['promoOptin'] = gettextCatalog.getString('Opt-in (Promotion)');
   defaults.strings.labels['contestOptin'] = gettextCatalog.getString('Opt-in (Contest)');
   defaults.strings.labels['salesOptin'] = gettextCatalog.getString('Opt-in (Sales)');
   defaults.strings.labels['termsAgree'] = gettextCatalog.getString('Terms Agreement');

   defaults.strings.descriptions['contactOptin'] = gettextCatalog.getString('I would like to receive further communications from the brand.');
   defaults.strings.descriptions['promoOptin'] = gettextCatalog.getString('I agree to have my social photos be used to promote the brand.');
   defaults.strings.descriptions['contestOptin'] = gettextCatalog.getString('I would like to receive information about this contest.');
   defaults.strings.descriptions['salesOptin'] = gettextCatalog.getString('I would like to be contacted by a sales agent to learn more.');
   defaults.strings.descriptions['termsAgree'] = gettextCatalog.getString('I agree to the terms of use.');

   defaults.strings.placeholders['gender'] = gettextCatalog.getString('-- Select Gender --');
   defaults.strings.placeholders['countryPlaceholder'] = gettextCatalog.getString('-- Select Country --');
   defaults.strings.placeholders['locationPlaceholder'] = gettextCatalog.getString('-- Select Location --');

   _.each(defaults.strings.labels, (v, k) => {
      defaults.strings.titles[k] = v;
   });

   defaults.strings.titles['eventDetails'] = 'Event Details';
   defaults.strings.titles['textLabel'] = 'Text Label';
   defaults.strings.titles['divider'] = 'Divider';
   defaults.strings.titles['addressSearch'] = 'Address /w Search';
}

class FormEditorField {
   field:ExperienceField;

   childWidth:number;
   childHeight:number;

   editable = true;
   deletable = true;

   survey:any;

   get sizeX() { return this.field.sizeX; }
   set sizeX(v:number) { this.field.sizeX = v; }

   get sizeY() { return this.field.sizeY; }
   set sizeY(v:number) { this.field.sizeY = v; }

   get row() { return this.field.row; }
   set row(v:number) { this.field.row = v; }

   get col() { return this.field.col; }
   set col(v:number) { this.field.col = v; }
}

export class FormEditorController implements ng.IComponentController {
   static $inject = [
      '$q', '$uibModal', 'utils', 'l10n', 'surveyItemsApi', 'session'
   ];

   constructor(
      private $q:ng.IQService,
      private $uibModal,
      private utils,
      private l10n,
      private surveyItemsApi,
      private session
   ) { }

   $onInit() {
      if (this.singleColumn) {
         this.gridsterSettings.minSizeX = 2;
      }

      if (this.webForm) {
         this.gridsterSettings.pushing = true;
         this.gridsterSettings.floating = true;
         this.gridsterSettings.swapping = false;
      }

      this.tinymceOptions = ng.extend({}, tinymceDefaults, this.tinymceOptions);

      // hack to enable opening field modal via settings accordion
      // ideally the add button would be inside this component
      this.editorPageCtrl.page['addNewField'] = (opts) => this.openFieldModal(opts);

      this.brandSettings =  ng.copy(this.session.getBrand().settings.experience);
   }

   $onChanges(changes:ng.IOnChangesObject) {
      if (changes.bgColor && this.bgColor) {
         this.updateStyles(this.bgColor);
      }

      if (changes.language && !changes.language.isFirstChange()) {
         // Resize survey fields on language change
         for (let field of this.form) {
            this.initSurveyField(field);
         }
      }

      if (changes.fields) {
         this.init();
      }
   }

   editorPageCtrl:EditorPageController;

   /**
    * Renders buttons and toggles instead of radio and checkboxes
    */
   buttonMode:boolean;

   /**
    * Limit field layout to single column, instead of default 2 column
    */
   singleColumn:boolean;

   /**
    * Apply grid UI settings for use with web forms (i.e. RSVP site)
    */
   webForm:boolean;

   /**
    * Color used to dynamically apply contrasting UI control color
    */
   bgColor:string;

   /**
    * Currently selected editor language. Why use binding instead of getting
    * from `editorPageCtrl.editorCtrl.model.language`? With the binding we
    * can monitor changes to language and resize fields.
    */
   language:string;

   // FIXME why maintain two arrays of fields?
   // make a model that wraps the input field and provides properties needed
   // by this editor and proxies the changes to the data.
   // ideally there would be an expression defined in the bindings for
   // sending changes to the fields back to the consumer.

   // experience fields from the model data
   fields:ExperienceField[];

   // field data formatted for use in the form editor
   form:any[];

   // custom field settings are applied to our Brown-Forman RSVP and Self Reg Sites
   org: any;

   // brand settngs to overwrite (standard) field text
   brandSettings: any;

   /**
    * Gridster styles
    * @type {{dropBackground: string, boxBorder: string, dragBackground: string, dragColor: string}}
    */
   style = {
      dropBackground: '#ddd',
      boxBorder: '1px solid #ececec',
      dragBackground: '#5587b1',
      dragColor: '#fff',
      controlColor: '#000'
   };

   tinymceOptions;
   gridsterSettings = ng.copy(gridsterDefaults);

   get languages() {
      return this.editorPageCtrl.editorCtrl.model.languages;
   }

   isStandard(key:string, type:string) {
      return typeof overrides.standard[key] != 'undefined' && type != 'optin';
   }

   isSurvey(type:string) {
      return ['surveyBoolean', 'surveyText', 'surveyOption', 'surveyMultioption'].indexOf(type) > -1;
   }

   isTextLabel(type:string) {
      return type == 'textLabel';
   }

   private updateStyles(bgColor:string) {
      let c = bgColor.substring(1); // strip #
      let rgb = parseInt(c, 16);    // convert rrggbb to decimal
      let r = (rgb >> 16) & 0xff;   // extract red
      let g = (rgb >>  8) & 0xff;   // extract green
      let b = (rgb >>  0) & 0xff;   // extract blue

      let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      if (luma >= 175) {
         this.style.dropBackground = '#ddd';
         this.style.boxBorder = '1px solid #ECECEC';
         this.style.dragBackground = '#5587B1';
         this.style.dragColor = '#fff';
         this.style.controlColor = '#000';
      } else if (luma < 175 && luma > 100) {
         this.style.dropBackground = 'rgba(34, 34, 34, 0.35)';
         this.style.boxBorder = '1px solid rgba(97, 97, 97, 0.32)';
         this.style.dragBackground = 'rgba(0, 0, 0, 0.4)';
         this.style.dragColor = '#fff';
         this.style.controlColor = 'rgba(255, 255, 255, 0.64)';
      } else if (luma <= 100) {
         this.style.dropBackground = 'rgba(255, 255, 255, 0.15)';
         this.style.boxBorder = '1px solid rgba(255, 255, 255, 0.19)';
         this.style.dragBackground = 'rgba(255, 255, 255, 0.17)';
         this.style.dragColor = '#fff';
         this.style.controlColor = 'rgba(255, 255, 255, 0.41)';
      }
   }

   private calculateChildDimensions(maxW:number, children:JQuery[]) {
      let w = 0;
      let h = 0;

      for (let child of children) {
         $('body').append(child);

         let childElement = child[0] as HTMLElement;

         if (childElement.offsetWidth > w) {
            w = childElement.offsetWidth;
         }

         if (childElement.offsetHeight > h) {
            h = childElement.offsetHeight;
         }

         child.detach();
      }

      w += 20;

      if (w >= maxW * 0.5) {
         w = maxW;
      }

      for (let child of children) {
         $('body').append(child);

         child.css('width', w + 'px');

         let childElement = child[0] as HTMLElement;
         if (childElement.offsetHeight > h) {
            h = childElement.offsetHeight;
         }

         child.remove();
      }

      return {
         width: w,
         height: h
      };
   }

   private wrapProperties(myField, inField:ExperienceField) {
      // various events such as font size changes could cause gridster to
      // adjust field position/size and we need to propagate those changes
      // back to the input field model.
      // decorate the locale field model with get/set that go directly to
      // the input field model.
      // ... again, ideally this would be handled in a class that perhaps
      // wraps the input field model (see FIXME on fields property)

      Object.defineProperties(myField, {
         sizeX: {
            get: () => inField.sizeX,
            set: (v) => inField.sizeX = v
         },
         sizeY: {
            get: () => inField.sizeY,
            set: (v) => inField.sizeY = v
         },
         col: {
            get: () => inField.col,
            set: (v) => inField.col = v
         },
         row: {
            get: () => inField.row,
            set: (v) => inField.row = v
         }
      });
   }

   private initSurveyField(field) {
      if (this.buttonMode && field.survey && ['surveyMultioption', 'surveyOption'].indexOf(field.type) > -1) {
         // Calculate the maximum width and height, so all options are consistently sized

         let parentDiv = $('[gridster]').parents('div')[0] as HTMLElement;
         let maxW = parentDiv.offsetWidth;
         if (field.sizeX == 1) {
            maxW /= 2;
         }

         let children = _.map(field.survey.surveyItemChoices, (survey:any) => {
            let ele = ng.element('<div></div>');
            ele.html(this.l10n.getTranslatedConfig(survey.label, this.language));

            ele.css({
               'position': 'absolute',
               'top': '-9999px',
               'left': '-9999px',
               'font-size': '20px',
               'display': 'inline-block',
               'border': '1px solid #000',
               'padding': '5px',
               'max-width': maxW + 'px',
               'font-family': window.getComputedStyle($('[gridster]')[0])['font-family']
            });

            return ele;
         });

         let dimensions = this.calculateChildDimensions(maxW, children);

         field.childWidth = dimensions.width > 0 ? dimensions.width : null;
         field.childHeight = dimensions.height > 0 ? dimensions.height : null;
      }

      return field;
   }

   private initSurvey(field:ExperienceField):ng.IPromise<any> {
      return this.surveyItemsApi.get(field.surveyId).then(res => {
         let obj = ng.copy(field) as any;
         obj.key = field.key.toString();
         obj.editable = true;
         obj.deletable = true;
         obj.survey = res;

         obj = this.initSurveyField(obj);
         this.wrapProperties(obj, field);

         return obj;
      });
   }

   private localizeField(field:ExperienceField, languages:string[]) {
      // per client request, B-F to display "Location" in place of "Country"
      if (this.org.slug.indexOf('brown-forman') >= 0 && field.key == 'country') {
         this.l10n.translateObject(field, 'label', defaults.strings.labels['location'], languages);
      } else if (defaults.strings.labels[field.key]) {
         this.l10n.translateObject(field, 'label', defaults.strings.labels[field.key], languages);
      }

      if (defaults.strings.descriptions[field.key]) {
         this.l10n.translateObject(field, 'description', defaults.strings.descriptions[field.key], languages);
      }

      if (defaults.strings.placeholders[field.key]) {
         this.l10n.translateObject(field, 'placeholder', defaults.strings.placeholders[field.key], languages);
      }
   }

   private initDemographic(field:ExperienceField) {
      // this will run form componet is intialized
      // we use it to populate default translations for fields
      // this mutates original field so that any translations for new languages
      // will be persisted in experience object now (model.dirty == true)
      this.localizeField(field, this.languages);

      var obj = ng.copy(field) as any;
      obj.editable = true;
      obj.deletable = true;

      let def = _.find(defaults.standard, d => d.key == obj.key);

      if (def) {
         obj = ng.extend({}, def, obj);
      }

      obj = ng.extend(obj, overrides.standard[obj.key]);

      // per client request, B-F users cannot remove first name, last name, email, dob, and country fields from the RSVP and Self Reg Editors
      if (this.org.slug.indexOf('brown-forman') >= 0 && ['firstNane', 'lastName', 'email', 'dateOfBirth', 'country'].includes(field.key)) {
         obj.deletable = false;
      }

      this.wrapProperties(obj, field);
      return this.$q.resolve(obj);
   }

   // Handles both divider and eventDetails
   private initUneditableField(field:ExperienceField) {
      let obj = ng.copy(field) as any;
      obj.key = field.key.toString();
      obj.editable = false;
      obj.deletable = true;

      this.wrapProperties(obj, field);
      return this.$q.resolve(obj);
   }

   private initTextLabel(field:ExperienceField) {
      let obj = ng.copy(field) as any;
      obj.key = field.key.toString();
      obj.editable = true;
      obj.deletable = true;

      this.wrapProperties(obj, field);
      return this.$q.resolve(obj);
   }

   private init() {
      this.org = this.session.getOrg();

      let fieldPromises = _.map(this.fields, f => {
         if (f.surveyId) {
            return this.initSurvey(f);
         } else if (f.type == 'divider' || f.type == 'eventDetails') {
            return this.initUneditableField(f);
         } else if (f.type == 'textLabel') {
            return this.initTextLabel(f);
         } else {
            return this.initDemographic(f);
         }
      });

      this.$q.all(fieldPromises).then(form => this.form = form);
   }

   private getNextRow() {
      let newRow = 0;

      for (let field of this.form) {
         if (field.col === 0 && (field.row + field.sizeY) > newRow) {
            newRow = field.row + field.sizeY;
         }
      }

      return newRow;
   }

   openFieldModal(opts:{disabled?:string[]}) {
      if (!opts) {
         opts = { disabled: [] };
      }

      let modal = this.$uibModal.open({
         size: 'lg',
         backdrop: 'static',
         templateUrl: addStandardViewUrl,
         controller: 'FormAddStandardController as ctrl',
         resolve: {
            formEditor: () => this,
            options: () => opts
         }
      });

      modal.result.then((field) => {
         if (field == defaults.textLabel) {
            this.addText();
         } else if (field == defaults.divider || field == defaults.eventDetails){
            this.addUneditableField(field);
         } else {
            this.addStandard(field);
         }
      });
   }

   hasField(key:string) {
      if (_.any(this.fields, f => f.key == key)) {
         return true;
      }

      // I would prefer to have this in field definition, but properties
      // specific to the frontend will cause server to error
      const conflicts = {
         address: 'addressSearch',
         addressSearch: 'address'
      };

      if (overrides.standard[key] &&
         _.any(this.fields, f => f.key == conflicts[key])) {

         return true;
      }

      return false;
   }

   addStandard(field) {
      let obj = ng.copy(field);
      obj.col = 0;
      obj.row = this.getNextRow();

      this.localizeField(obj, this.languages);

      // overwrite default content with text set in Brand -> Default Experience Content
      if (this.brandSettings[field.key] && !ng.equals({}, this.brandSettings[field.key])) {
         for (let _lang of this.languages) {
            if (this.brandSettings[field.key][_lang] && !ng.equals({}, this.brandSettings[field.key][_lang])) {
               obj.description[_lang] = this.brandSettings[field.key][_lang];
            }
         }
      }

      this.addOrUpdateField(obj);
   }

   addText() {
      let obj = ng.copy(defaults.textLabel) as any;
      obj.col = 0;
      obj.row = this.getNextRow();
      obj.key = this.utils.generateUniqueId();

      this.addOrUpdateField(obj);

      this.edit(obj);
   }

   addSurvey(type) {
      let modal = this.$uibModal.open({
         size: 'md',
         backdrop: 'static',
         templateUrl: addSurveyViewUrl,
         controller: 'FormAddSurveyController',
         resolve: {
            surveyType: () => type,
            formEditor: () => this
         }
      });

      modal.result.then((field) => {
         var obj = ng.copy(field);
         obj.col = 0;
         obj.row = this.getNextRow();
         obj.key = this.utils.generateUniqueId();

         this.addOrUpdateField(obj);

         this.edit(obj);
      });
   }

   // Handles divider and eventDetails
   addUneditableField(field:any) {
      let obj = ng.copy(field) as any;

      obj.col = 0;
      obj.row = this.getNextRow();
      obj.key = this.utils.generateUniqueId();

      this.addOrUpdateField(obj);
   }

   /**
    * Persists changes to field in this.form, back to this.fields
    * ... because bonkers, see FIXME on fields property
    */
   private addOrUpdateField(field) {
      let i = _.findIndex(this.form, f => f.key == field.key);
      if (i !== -1) {
         this.form[i] = field;
      } else {
         this.form.push(field);
      }

      let o = ng.copy(field);
      delete o.editable;
      delete o.deletable;

      if (o.survey) {
         o.surveyId = o.survey.id;
         delete o.survey;
         delete o.childWidth;
         delete o.childHeight;
      }

      this.wrapProperties(field, o);

      i = _.findIndex(this.fields, f => f.key == field.key);
      if (i !== -1) {
         this.fields[i] = o;
      } else {
         this.fields.push(o);
      }
   }

   edit(value) {
      let modal = this.$uibModal.open({
         size: 'md',
         backdrop: 'static',
         templateUrl: fieldSettingsViewUrl,
         controller: 'FormFieldSettingsController as ctrl',
         resolve: {
            formEditor: () => this,
            field: () => value
         }
      });

      modal.result.then(field => {
         field = this.initSurveyField(field);
         this.addOrUpdateField(field);
      });
   }

   delete(key) {
      this.form.splice(key, 1);
      this.fields.splice(key, 1);
   }

   bool(val:string) {
      return this.utils.parseBoolean(val);
   }

   onElementHeightChange(item, height:number) {
      // Need to persist changes to this.fields since
      // item is in this.form and not this.fields array
      // why? see FIXME on fields property
      let i = this.form.indexOf(item);
      let field = this.fields[i];

      item.minSizeY = Math.max(Math.ceil((height + 15) / 22), 2);
      if (item.sizeY < item.minSizeY) {
         item.sizeY = item.minSizeY;
      }

      field.sizeY = item.sizeY;
      field.minSizeY = item.minSizeY;
   }

   getChoices(item) {
      return _.chain(item.survey.surveyItemChoices)
         .filter(c => !_.contains(item.hiddenChoices, c.key))
         .sortBy('index')
         .value();
   }
}

ng.module('e360').component('formEditor', {
   require: {
      editorPageCtrl: '^editorPage'
   },
   templateUrl: require('./form-editor.html'),
   controller: FormEditorController,
   bindings: {
      fields: '<',
      buttonMode: '<',
      singleColumn: '<',
      webForm: '<',
      tinymceOptions: '<',
      bgColor: '<',
      language: '<'
   }
});
